import type { LoginFulfilledAction, LogoutAction } from "domains/authentication/actionTypes";
import { AuthenticationType } from "domains/authentication/actionTypes";

export const authenticateSuccess = (idToken: string): LoginFulfilledAction => ({
  type: AuthenticationType.LOGIN_FULFILLED,
  payload: { idToken },
});

export const unauthenticate = (payload?: LogoutAction["payload"]): LogoutAction => ({
  type: AuthenticationType.LOGOUT,
  payload,
});
